"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var reference_1 = require("../reference");
var JobReference = /** @class */ (function (_super) {
    __extends(JobReference, _super);
    function JobReference() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.display = 'Job Reference';
        return _this;
    }
    return JobReference;
}(reference_1.Reference));
exports.JobReference = JobReference;
